import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';

import { INotification } from '../../../shared/models/notification.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    standalone: false
})
export class NotificationsComponent {
  @Input() notifications: INotification[];

  @Output() removeNotification = new EventEmitter<string>();
  @Output() clearNotifications = new EventEmitter();

  removeFromNotifications(notificationUUID: string) {
    this.removeNotification.emit(notificationUUID);
  }

  clearAllNotifications() {
    this.clearNotifications.emit();
  }
}
